import styled from 'styled-components'
import Button from '../../common/Button'

const Container = styled.section`
  border: #cecfcf 1px solid;
  margin-bottom: 10px;
  border-radius: 3px;
`
const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  background: #e8e8e8;
  padding: 10px 15px;
  line-height: 30px;
  cursor: pointer;
`
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-self: start;
  align-self: center;
  font-size: 18px;
`
const ButtonContainer = styled.div`
  justify-self: end;
  align-self: center;
`
const Caret = styled.i`
  color: ${props => props.open ? '#56565a' : '#75AFB6'};
  padding: 0px 5px;
  display: inline-block;
  width: 12px;
  box-sizing: content-box;
`
const GreyButton = styled(Button)`
  background: #b4b5b6;
  padding: 5px 20px;
  &:hover {
    background: #9a9c9d;
  }
`
const DocInfo = styled.div`
  justify-self: end;
`
const DocumentsContainer = styled.div`
  padding: ${props => props.isOpen ? '20px' : '0px'};
`
const DocumentsContainerRenewed = styled.div`
  padding: ${props => props.isOpen ? '20px 0' : '0px'};
`

const DocumentRenewedWrapper = styled.div`
  padding: 0 20px;
`

export {
  Container,
  Header,
  TitleContainer,
  ButtonContainer,
  Caret,
  GreyButton,
  DocInfo,
  DocumentsContainer,
  DocumentsContainerRenewed,
  DocumentRenewedWrapper
}